// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* menu-bar should go over monitors, alerts and tutorials */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.monitor_monitor-container_DNlTT {
    position: absolute;
    background: var(--ui-primary-default);
    z-index: 48;
    border: 1px solid var(--ui-black-transparent-default);
    border-radius: calc(0.5rem / 2);
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 0.75rem;
    transition: box-shadow 0.2s;
    pointer-events: all;
    overflow: hidden;
}

.monitor_monitor_JDur_:hover {
    cursor: pointer;
}

.monitor_dragging_nzOwU {
    z-index: 1010;
    box-shadow: 3px 3px 5px #888888;
}

.monitor_default-monitor_xY9H4 {
    display: flex;
    flex-direction: column;
    padding: 3px;
}

.monitor_label_EtjPt {
    font-weight: bold;
    text-align: center;
    margin: 0 5px;
}

.monitor_value_NOCRb {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 40px;
    text-align: center;
    margin: 0 5px;
    border-radius: calc(0.5rem / 2);
    padding: 0 2px;
    white-space: pre-wrap;
    transform: translateZ(0); /* Fixes flickering in Safari */
}

.monitor_large-value_KpNzr {
    min-height: 1.4rem;
    min-width: 3rem;
    padding: 0.1rem 0.25rem;
    text-align: center;
    font-size: 1rem;
    white-space: pre-wrap;
    transform: translateZ(0); /* Fixes flickering in Safari */
}

.monitor_row_HYHrj {
    display: flex;
    flex-direction: row;
}

.monitor_slider_zXbBG {
    width: 100%;
    transform: translateZ(0); /* Fixes flickering in Safari */
}

.monitor_list-monitor_i_tiO {
    display: flex;
    flex-direction: column;
}

.monitor_list-header_X1jz5 {
    background: var(--ui-white-default);
    border-bottom: 1px solid var(--ui-black-transparent-default);
    text-align: center;
    padding: 3px;
    font-size: 0.75rem;
    font-weight: bold;
    color: var(--text-primary-default);
    width: 100%;
}

.monitor_list-body_frcPa {
    background: var(--ui-primary-default);
    width: 100%;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    flex-grow: 1;
}

.monitor_list-row_L_OUr {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding: 2px;
    flex-shrink: 0;
    transform: translateZ(0); /* Keep sharp when scaled */
}

.monitor_list-index_pmbJu {
    font-weight: bold;
    color: var(--text-primary-default);
    margin: 0 3px;
}

.monitor_list-value_PBoqB {
    min-width: 40px;
    text-align: left;
    margin: 0 3px;
    border-radius: calc(0.5rem / 2);
    border: 1px solid var(--ui-black-transparent-default);
    flex-grow: 1;
    height: 22px;
}

.monitor_list-footer_eEZ8e {
    background: var(--ui-white-default);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 3px;
    font-size: 0.75rem;
    font-weight: bold;
    border-top: 1px solid var(--ui-black-transparent-default);
    color: var(--text-primary-default);
}

.monitor_list-empty_dV2br {
    text-align: center;
    width: 100%;
    padding: 5px;
}

.monitor_input-wrapper_pzh0W {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    background: rgba(0, 0, 0, 0.1);
}

.monitor_value-inner_QcuAb {
    padding: 3px 5px;
    min-height: 22px;
    overflow: hidden; /* Don't let long values escape container */
    text-overflow: ellipsis;
    -webkit-user-select: text;
       -moz-user-select: text;
        -ms-user-select: text;
            user-select: text; /* Allow selecting list values for 2.0 compatibility, only relevant in player */
    white-space: pre;
}

.monitor_list-input_Bu7gJ {
    padding: 3px 5px;
    border: 0;
    background: none;
    outline: none;
    font-size: 0.75rem;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    /* Workaround for Firefox */
    width: 0;
    flex: 1 1 auto;
}

.monitor_remove-button_bzoDQ {
    padding: 0;
    padding-right: 5px;
    cursor: pointer;
}

.monitor_add-button_d7ydE {
    cursor: pointer;
    margin-right: 3px;
}

.monitor_resize-handle_Fay7Y {
    cursor: nwse-resize;
    margin-left: 3px;
}

.monitor_footer-length_W2wT0 {
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/monitor/monitor.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,2DAA2D;;AAE3D,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;IACI,kBAAkB;IAClB,qCAAqC;IACrC,WAAW;IACX,qDAAqD;IACrD,+BAA+B;IAC/B,2DAA2D;IAC3D,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,+BAA+B;IAC/B,cAAc;IACd,qBAAqB;IACrB,wBAAwB,EAAE,+BAA+B;AAC7D;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,wBAAwB,EAAE,+BAA+B;AAC7D;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,wBAAwB,EAAE,+BAA+B;AAC7D;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mCAAmC;IACnC,4DAA4D;IAC5D,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,wBAAwB,EAAE,2BAA2B;AACzD;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;IAClC,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,+BAA+B;IAC/B,qDAAqD;IACrD,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,yDAAyD;IACzD,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB,EAAE,2CAA2C;IAC7D,uBAAuB;IACvB,yBAAyB;OACtB,sBAAsB;QACrB,qBAAqB;YACjB,iBAAiB,EAAE,+EAA+E;IAC1G,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,2DAA2D;IAC3D,2BAA2B;IAC3B,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* menu-bar should go over monitors, alerts and tutorials */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.monitor-container {\n    position: absolute;\n    background: var(--ui-primary-default);\n    z-index: 48;\n    border: 1px solid var(--ui-black-transparent-default);\n    border-radius: calc(0.5rem / 2);\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-size: 0.75rem;\n    transition: box-shadow 0.2s;\n    pointer-events: all;\n    overflow: hidden;\n}\n\n.monitor:hover {\n    cursor: pointer;\n}\n\n.dragging {\n    z-index: 1010;\n    box-shadow: 3px 3px 5px #888888;\n}\n\n.default-monitor {\n    display: flex;\n    flex-direction: column;\n    padding: 3px;\n}\n\n.label {\n    font-weight: bold;\n    text-align: center;\n    margin: 0 5px;\n}\n\n.value {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-width: 40px;\n    text-align: center;\n    margin: 0 5px;\n    border-radius: calc(0.5rem / 2);\n    padding: 0 2px;\n    white-space: pre-wrap;\n    transform: translateZ(0); /* Fixes flickering in Safari */\n}\n\n.large-value {\n    min-height: 1.4rem;\n    min-width: 3rem;\n    padding: 0.1rem 0.25rem;\n    text-align: center;\n    font-size: 1rem;\n    white-space: pre-wrap;\n    transform: translateZ(0); /* Fixes flickering in Safari */\n}\n\n.row {\n    display: flex;\n    flex-direction: row;\n}\n\n.slider {\n    width: 100%;\n    transform: translateZ(0); /* Fixes flickering in Safari */\n}\n\n.list-monitor {\n    display: flex;\n    flex-direction: column;\n}\n\n.list-header {\n    background: var(--ui-white-default);\n    border-bottom: 1px solid var(--ui-black-transparent-default);\n    text-align: center;\n    padding: 3px;\n    font-size: 0.75rem;\n    font-weight: bold;\n    color: var(--text-primary-default);\n    width: 100%;\n}\n\n.list-body {\n    background: var(--ui-primary-default);\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    overflow-x: hidden;\n    flex-grow: 1;\n}\n\n.list-row {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    align-items: center;\n    padding: 2px;\n    flex-shrink: 0;\n    transform: translateZ(0); /* Keep sharp when scaled */\n}\n\n.list-index {\n    font-weight: bold;\n    color: var(--text-primary-default);\n    margin: 0 3px;\n}\n\n.list-value {\n    min-width: 40px;\n    text-align: left;\n    margin: 0 3px;\n    border-radius: calc(0.5rem / 2);\n    border: 1px solid var(--ui-black-transparent-default);\n    flex-grow: 1;\n    height: 22px;\n}\n\n.list-footer {\n    background: var(--ui-white-default);\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    padding: 3px;\n    font-size: 0.75rem;\n    font-weight: bold;\n    border-top: 1px solid var(--ui-black-transparent-default);\n    color: var(--text-primary-default);\n}\n\n.list-empty {\n    text-align: center;\n    width: 100%;\n    padding: 5px;\n}\n\n.input-wrapper {\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    background: rgba(0, 0, 0, 0.1);\n}\n\n.value-inner {\n    padding: 3px 5px;\n    min-height: 22px;\n    overflow: hidden; /* Don't let long values escape container */\n    text-overflow: ellipsis;\n    -webkit-user-select: text;\n       -moz-user-select: text;\n        -ms-user-select: text;\n            user-select: text; /* Allow selecting list values for 2.0 compatibility, only relevant in player */\n    white-space: pre;\n}\n\n.list-input {\n    padding: 3px 5px;\n    border: 0;\n    background: none;\n    outline: none;\n    font-size: 0.75rem;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    /* Workaround for Firefox */\n    width: 0;\n    flex: 1 1 auto;\n}\n\n.remove-button {\n    padding: 0;\n    padding-right: 5px;\n    cursor: pointer;\n}\n\n.add-button {\n    cursor: pointer;\n    margin-right: 3px;\n}\n\n.resize-handle {\n    cursor: nwse-resize;\n    margin-left: 3px;\n}\n\n.footer-length {\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `monitor_monitor-container_DNlTT`;
export { _1 as "monitor-container" };
export var monitorContainer = `monitor_monitor-container_DNlTT`;
export var monitor = `monitor_monitor_JDur_`;
export var dragging = `monitor_dragging_nzOwU`;
var _2 = `monitor_default-monitor_xY9H4`;
export { _2 as "default-monitor" };
export var defaultMonitor = `monitor_default-monitor_xY9H4`;
export var label = `monitor_label_EtjPt`;
export var value = `monitor_value_NOCRb`;
var _3 = `monitor_large-value_KpNzr`;
export { _3 as "large-value" };
export var largeValue = `monitor_large-value_KpNzr`;
export var row = `monitor_row_HYHrj`;
export var slider = `monitor_slider_zXbBG`;
var _4 = `monitor_list-monitor_i_tiO`;
export { _4 as "list-monitor" };
export var listMonitor = `monitor_list-monitor_i_tiO`;
var _5 = `monitor_list-header_X1jz5`;
export { _5 as "list-header" };
export var listHeader = `monitor_list-header_X1jz5`;
var _6 = `monitor_list-body_frcPa`;
export { _6 as "list-body" };
export var listBody = `monitor_list-body_frcPa`;
var _7 = `monitor_list-row_L_OUr`;
export { _7 as "list-row" };
export var listRow = `monitor_list-row_L_OUr`;
var _8 = `monitor_list-index_pmbJu`;
export { _8 as "list-index" };
export var listIndex = `monitor_list-index_pmbJu`;
var _9 = `monitor_list-value_PBoqB`;
export { _9 as "list-value" };
export var listValue = `monitor_list-value_PBoqB`;
var _a = `monitor_list-footer_eEZ8e`;
export { _a as "list-footer" };
export var listFooter = `monitor_list-footer_eEZ8e`;
var _b = `monitor_list-empty_dV2br`;
export { _b as "list-empty" };
export var listEmpty = `monitor_list-empty_dV2br`;
var _c = `monitor_input-wrapper_pzh0W`;
export { _c as "input-wrapper" };
export var inputWrapper = `monitor_input-wrapper_pzh0W`;
var _d = `monitor_value-inner_QcuAb`;
export { _d as "value-inner" };
export var valueInner = `monitor_value-inner_QcuAb`;
var _e = `monitor_list-input_Bu7gJ`;
export { _e as "list-input" };
export var listInput = `monitor_list-input_Bu7gJ`;
var _f = `monitor_remove-button_bzoDQ`;
export { _f as "remove-button" };
export var removeButton = `monitor_remove-button_bzoDQ`;
var _10 = `monitor_add-button_d7ydE`;
export { _10 as "add-button" };
export var addButton = `monitor_add-button_d7ydE`;
var _11 = `monitor_resize-handle_Fay7Y`;
export { _11 as "resize-handle" };
export var resizeHandle = `monitor_resize-handle_Fay7Y`;
var _12 = `monitor_footer-length_W2wT0`;
export { _12 as "footer-length" };
export var footerLength = `monitor_footer-length_W2wT0`;
export default ___CSS_LOADER_EXPORT___;
